import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { CommonDownloadLinkFromS3 } from 'src/app/shared/common/commonDownloadLinkFromS3';
import { constants } from 'src/app/shared/common/contants';
import { AttributeMappingConfigService } from 'src/app/shared/services/attribute-mapping-config.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
    selector: 'app-baseline-mapping-view-popup',
    templateUrl: './baseline-mapping-view-popup.component.html',
    styleUrls: ['./baseline-mapping-view-popup.component.scss'],
    standalone: false
})
export class BaselineMappingViewPopupComponent implements OnInit {
gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;

  getdata: any = [];
  reportData: any;
  userid: any;
  fieldslist: any = {};

  backgroundColorButton = "";

  constructor(private commonService: CommonService, private snackbar: MatSnackBar, private constants: constants, public dialogref: MatDialogRef<BaselineMappingViewPopupComponent>, private loginService: LoginService, private localStorageSettings: LocalStorageSettingsService,private mappingAttributeServices:AttributeMappingConfigService,private spinner: NgxUiLoaderService) {
    //cell rendering in ag-grid
    this.components = {
      downloadReportRef: CommonDownloadLinkFromS3,
    }

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  ngOnInit(): void {
    let json=["Product Name","Product Family"]
    let json2=[
      { "Product Name": "product1", "Product Family": "Family1" },
      { "Product Name": "product2", "Product Family": "Family2" }
    ]
    console.log(JSON.stringify(json))
    console.log(JSON.stringify(json2))
    this.columnDefs = [
      {
        headerName: 'Mapping File Name',
        headerTooltip: 'Mapping File Name',
        tooltipValueGetter: (params) => 'Mapping File Name : ' + params.value,
        field: 'mappingversionfilename',
        filter: 'agTextColumnFilter',
        width: 230
      },
      {
        headerName: 'Mapping Version',
        headerTooltip: 'Mapping Version',
        tooltipValueGetter: (params) => 'Mapping Version : ' + params.value,
        field: 'mappingversion',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Mapping Version Path',
        headerTooltip: 'Type',
        cellRenderer: "downloadReportRef",
        field: 'mappingversionpath',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Created By',
        headerTooltip: 'Created By',
        tooltipValueGetter: (params) => 'Created By : ' + params.value,
        field: 'createdby',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Created Date And Time',
        headerTooltip: 'Created Date And Time',
        tooltipValueGetter: (params) => 'Created Date And Time : ' + params.value,
        field: 'createdDateAndTime',
        filter: 'agTextColumnFilter',
        width: 200
      }
    ]
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
  }

  onPaginationChanged() {
    if (this.gridAPI.api) {
      this.lastPage = this.gridAPI.api.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.api.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.api.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.api.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {
    this.gridAPI.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.api.paginationGoToLastPage();
  }

  closePopup() {
    this.dialogref.close(null)
  }

   onGridReady(params) {

    this.spinner.start();
    this.gridAPI = params;
    let dnsId = this.localStorageSettings.getSettings("dnsName");;
  this.mappingAttributeServices.retreiveMappingBaselineDetails(dnsId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.gridAPI.api.setGridOption('rowData', [])
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        console.log(response);
        this.gridAPI.api.setGridOption('rowData', response)
        this.spinner.stop();
      }
  })
  }
}
